<style scoped>

</style>
<template>
  <div>
    <Modal
      v-model="display"
      :width="900"
      :closable="false"
      :mask-closable="false"
      title="历史记录"
    >
      <Table
        border
        :columns="historiesVersionsFields"
        :data="formProps"
        :loading="loading"
      />
      <div slot="footer">
        <Button
          @click="close"
        >
          关闭
        </Button>
      </div>
    </Modal>
  </div>
</template>
<script>
  import { histories_versions_fields } from '../fields'
  import { columnFile } from '../utils'
  import { gotoQualificationFileApi } from '../service'
  export default {
    props: {
      display: {
        type: Boolean,
        default:() => 0
      },
      formProps: {
        type: Array,
        default:() => ([])
      },
      loading:{
        type:Boolean,
        default:() => false
      }
    },
    data() {
      return {
        
      }
    },
    computed:{
      historiesVersionsFields() {
        return [columnFile.call(this, gotoQualificationFileApi)].concat(histories_versions_fields)
      }
    },
    methods: {
      close() {
        this.$emit('close')
      },
    }
  }
</script>
